var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header-search', {
    staticClass: "header-search--outlined-tile",
    attrs: {
      "InputTag": "u-text-field-outlined-tile"
    }
  }, [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }